module.exports = __webpack_public_path__ + "media/images/lb/576-20881f5e0087c66718af84e415f5ff14.svg";